import { Visibility } from '@mui/icons-material';
import Style from '../styles/RTMFilterView.module.scss';
import { filterElement, RTMFilterViewProps } from '../types/RTMTypes';
import { t } from 'i18next';

const RTMFilterView = (props: RTMFilterViewProps) => {
  const renderFilterElements = (categoryName: 'families' | 'productTypes' | 'products', icon = false) => {
    return (
      <>
        <span className='title-category active' onClick={() => props.refreshTable()}>
          {t('general.' + categoryName)} {icon && <Visibility />}
        </span>
        {props.tableFilter[categoryName].map((element: filterElement) => {
          return (
            <div
              key={element.id}
              className={`option-filter ${element.status}`}
              onClick={() => props.handleFilter(categoryName, element.id, element.status)}
            >
              <div className={`custom-checkbox ${element.status}`}>
                <div className={`checkmark ${element.status === 'all' ? 'visible' : ''}`} />
                <div className={`dashmark ${element.status === 'some' ? 'visible' : ''}`} />
              </div>
              <span className='option-text'>{element.name}</span>
            </div>
          );
        })}
      </>
    );
  };

  return (
    <div className={Style.RTMFilterView}>
      <div className='RTMFilterView-container'>
        <div className='category'>{renderFilterElements('families', true)}</div>
        <div className='category'>{renderFilterElements('productTypes')}</div>
        <div className='category'>{renderFilterElements('products')}</div>
      </div>
    </div>
  );
};

export default RTMFilterView;
